import { readonly, shallowRef } from 'vue'

const visible = shallowRef(false)
const percent = shallowRef(0)

let progressTimer: ReturnType<typeof setInterval> | undefined
let finishTimer: ReturnType<typeof setTimeout> | undefined

function clearTimers() {
  if (progressTimer !== undefined) {
    clearInterval(progressTimer)
    progressTimer = undefined
  }
  if (finishTimer !== undefined) {
    clearTimeout(finishTimer)
    finishTimer = undefined
  }
}

/** 开始路由加载：快速起步后逐渐放缓，真实导航完成前最多停在 95%。 */
export function startRouteLoading() {
  clearTimers()
  visible.value = true
  percent.value = 8

  progressTimer = setInterval(() => {
    if (percent.value < 30) {
      percent.value = Math.min(percent.value + 8, 30)
    } else if (percent.value < 60) {
      percent.value = Math.min(percent.value + 4, 60)
    } else if (percent.value < 80) {
      percent.value = Math.min(percent.value + 2, 80)
    } else {
      percent.value = Math.min(percent.value + 1, 95)
    }
  }, 250)
}

/** 完成路由加载：推进到 100%，短暂展示完成态后隐藏。 */
export function finishRouteLoading() {
  clearTimers()
  if (!visible.value) return

  percent.value = 100
  finishTimer = setTimeout(() => {
    visible.value = false
    percent.value = 0
    finishTimer = undefined
  }, 200)
}

/** 路由加载异常时立即清理进度状态，避免永久停留。 */
export function failRouteLoading() {
  clearTimers()
  visible.value = false
  percent.value = 0
}

export function useRouteLoading() {
  return {
    visible: readonly(visible),
    percent: readonly(percent),
  }
}
